@switch (orderStatus) {
  @case ('CONFIRMED') {
    <span class="fa-stack text-portbase-green">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-fw fa-lg fa-check fa-stack-1x fa-inverse" title="Order confirmed"></i>
    </span>
  }
  @case ('REJECTED') {
    <span class="fa-stack text-portbase-red">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-fw fa-lg fa-times fa-stack-1x fa-inverse" title="Order rejected"></i>
    </span>
  }
  @case ('CONFIRMED_NEW_PROPOSAL') {
    <span class="fa-stack text-portbase-orange">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-fw fa-lg fa-check fa-stack-1x fa-inverse" title="Order confirmed with new time proposal"></i>
    </span>
  }
  @case ('ETA_CHANGED') {
    <span class="fa-stack text-portbase-orange">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-fw fa-lg fa-check fa-stack-1x fa-inverse" title="ETA changed"></i>
    </span>
  }
  @case ('ETD_CHANGED') {
    <span class="fa-stack text-portbase-orange">
      <i class="fas fa-circle fa-stack-2x"></i>
      <i class="fas fa-fw fa-lg fa-check fa-stack-1x fa-inverse" title="ETD changed"></i>
    </span>
  }
  @case ('ORDERED') {
    <span class="fa-stack text-portbase-light-blue">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-fw fa-lg fa-paper-plane fa-stack-1x" title="Movement ordered"></i>
    </span>
  }
  @case ('REEVALUATED') {
    <span class="fa-stack text-portbase-light-blue">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-fw fa-lg fa-paper-plane fa-stack-1x" title="Movement ordered"></i>
    </span>
  }
  @default {
    <span class="fa-stack light-grey">
      <i class="fas fa-circle fa-stack-2x fa-inverse"></i>
      <i class="fas fa-fw fa-lg fa-route fa-stack-1x" title="Movement information"></i>
    </span>
  }
}
